module.exports = __webpack_public_path__ + "static/media/55@2x.5d97edb8.png";